import { render, staticRenderFns } from "./CourseEventDialog.vue?vue&type=template&id=7c144e2c&scoped=true&"
import script from "./CourseEventDialog.vue?vue&type=script&lang=js&"
export * from "./CourseEventDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c144e2c",
  null
  
)

export default component.exports